<template>
  <div>

    <Head title="Cutting Output Edit" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/blocks/cutting">Cutting Output</Link>
        <span class="text-orange-400 font-medium">/</span> {{ cutting.block }}/Edit
      </h1>
    </div>
    <div class="bg-white rounded-md shadow mb-3">
      <form @submit.prevent="update" @keydown.enter="$event.preventDefault()" @keyup.enter="$event.preventDefault()">
        <div class="flex flex-wrap -mb-2 -mr-6 p-8 w-full lg:w-full">
          <div class="w-full">
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <text-input class="hidden" v-model="form.output_id" />
              <text-input v-model="form.item_id" :error="form.errors.item_id" class="pb-2"
                placeholder="Scan Output Part No" />
              <span
                v-if="form.errors && form.errors.item_id"
                class="mt-3">
                <span class="form-error">{{ form.errors.item_id }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <text-input class="pb-2" v-model="form.size" placeholder="Size" />
              <span v-if="form.errors && form.errors.size" class="mt-3">
                <span class="form-error">{{ form.errors.size }}</span>
              </span>
              <span v-else>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <text-input class="pb-2" v-model="form.type"
                placeholder="Part Description" />
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <select-input v-model="form.quality" class="pb-2">
                <option :value="null">
                  Select Quality
                </option>
                <option v-for="quality in qualities" :value="quality.name">
                  {{ quality.name }}
                </option>
              </select-input>
              <span v-if="form.errors && form.errors.quality" class="mt-3">
                <span class="form-error">
                  {{ form.errors.quality }}
                </span>
              </span>
            </div>
            <div v-if="form.quality =='Discount'" class="pb-2 pr-6 w-full lg:w-4/4">
              <select-input v-model="form.discount_description" class="pb-2">
                <option :value="null">
                  Select Discount Descriptions
                </option>
                <option v-for="discount_description in discount_descriptions"
                  :value="discount_description.id">
                  {{ discount_description.name }}
                </option>
              </select-input>
              <span v-if="form.errors && form.errors.discount_description" class="mt-3">
                <span class="form-error">
                  {{ form.errors.discount_description }}
                </span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <text-input class="pb-2" v-model="form.quantity" :error="form.errors.quantity"
                placeholder="Quantity" />
                <span v-if="form.errors && form.errors.quantity" class="mt-3">
                <span class="form-error">
                  {{ form.errors.quantity }}
                </span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/4">
              <text-input class="pb-2" v-model="form.weight" :error="form.errors.weight"
                placeholder="Weight" />
                <span v-if="form.errors && form.errors.weight" class="mt-3">
                <span class="form-error">
                  {{ form.errors.weight }}
                </span>
              </span>
            </div>
          </div>
          <div class="pb-2 pr-6 w-full lg:w-full">
            <hr />
          </div>
          <div class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-orange px-3 py-2 text-xs" type="submit">
              Update Output
            </loading-button>
          </div>
        </div>
      </form>
    </div>
    <hr />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  props: {
    cutting: Object,
    qualities: Object,
    discount_descriptions: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        size: this.cutting.size,
        item_id: this.cutting.item_id,
        type: this.cutting.type,
        quality: this.cutting.quality,
        quantity: this.cutting.quantity,
        discount_description: this.cutting.discount_description_id,
        weight: this.cutting.weight,
        output_id: this.cutting.id,
      }),
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  methods: {
    update() {
      this.form.post(`/blocks/${this.cutting.id}/cuttings/post`, {
        onSuccess: () => {
          this.form.reset()
        }
      });
    },
  },
}
</script>